import React from 'react';
import { Redirect, Route, useLocation, useRouteMatch } from 'react-router-dom';
import { HelpCenterQuestion } from './HelpCenterQuestion';
import { HelpCenterQueryResult } from './HelpCenterQueryResult';
import { HelpCenterContent } from './HelpCenterContent';
import { Layout } from './layout';

export enum EHelpCenterRoutes {
  CONTENT = '/',
  CATEGORY = '/category',
  SEARCH = '/search'
}

export const NewHelpCenter: React.FC = () => {
  const { path } = useRouteMatch();
  const { pathname } = useLocation();

  React.useEffect(() => {
    (() => window.scrollTo({ top: 0, behavior: 'smooth' }))();
  }, [pathname]);

  return (
    <Layout>
      <Route exact path={`${path}`} component={HelpCenterContent} />

      <Route exact path={`${path}/help-manuals`} component={HelpCenterQuestion}>
        <Redirect to={`${path}${EHelpCenterRoutes.CONTENT}`} />
      </Route>

      <Route
        exact
        path={`${path}${EHelpCenterRoutes.CATEGORY}`}
        component={HelpCenterQuestion}
      >
        <Redirect to={`${path}${EHelpCenterRoutes.CONTENT}`} />
      </Route>

      <Route
        path={`${path}${EHelpCenterRoutes.CATEGORY}/:categoryId`}
        component={HelpCenterQuestion}
      />

      <Route
        path={`${path}${EHelpCenterRoutes.SEARCH}`}
        component={HelpCenterQueryResult}
      />
    </Layout>
  );
};
